// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__iYoCl","clickable":"styles_clickable__HspVK","disabled":"styles_disabled__2A4nB"};